import { formatDate } from '@angular/common';
import { DateTime } from '@syncfusion/ej2-charts';

export class Util {

    static isFieldEmpty(field: string) {
        if (field == null || field.length == 0)
            return true;

        return false;
    }

    static isNumberEmpty(field: number) {
        if (field == null)
            return true;

        return false;
    }

    static isDateEmpty(field: Date) {
        if (field == null) return true;
        return false;
    }

    static isValidDateTimeFromTo(date1: Date, date2: Date) {
        //console.log(date1.valueOf());
        //console.log(date2.valueOf());
        if (date1.valueOf()> date2.valueOf()) return false;
        return true;
    }

    static isOverDeadline(overDate: Date, nowDate: Date) {
        debugger;
        if (overDate.getTime() <= nowDate.getTime()) return true;
        return false;
    }

    static round(number, precision) {
        var factor = Math.pow(10, precision);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    };

    static replaceAll(str1: string, str2: string, str3: string, ignore: boolean) {
        return str1.replace(new RegExp(str2.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof (str3) == "string") ? str3.replace(/\$/g, "$$$$") : str3);
    }
    
    static getPath(url: string) {
        //http://
        //https:// length = 8

        if (url.length > 0) {
            let i = url.indexOf("/", 8);
            if (i != -1)
                return url.substring(i); 
        }

        return null;
    }

    static getPathWithoutParam(url: string) {
        //http://
        //https:// length = 8

        let path = Util.getPath(url);
        if (path != null) {
            let j = path.indexOf("/", 1);
            if (j != -1) {
                return path.substring(0, j);
            }
            else
                return path;
        }

        return null;
    }

    static getUrlWithoutParam(url: string) {
        if (url.length > 0) {
            let i = url.indexOf("/", 8);
            if (i != -1)
                return url.substring(0, i);
        }

        return null;
    }

    static getPathCode(url: string) {
        let i = url.lastIndexOf("/");
        if (i != -1)
            return +url.substring(i + 1);

        return 0;
    }

    static formatDate(val: Date) {
        if (val != null) {
            //return formatDate(dt, 'd-MMM-yyyy');

            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
            ];

            let dt = new Date(val);
            let d = dt.getDate();
            let m = dt.getMonth();
            let y = dt.getFullYear();

            return `${d}-${months[m]}-${y}`;
        }
        else
            return '';
    }
    static formatNumber(value: number) {
        return value ? value.toLocaleString("en-US") : "";
    }

    static toLocalTime(val?: Date) {
        if (val != null) {
            val = new Date(val);
        }
        return val;
    }

    static array2String(arr) {
        if (arr != null)
            return arr.join(',');
        else
            return arr;
    }

    static string2Array(str: string) {
        if (str != null)
            return str.split(',');
        else
            return null;
    }

    static array2String1(arr, str: string) {
        if (arr != null)
            return arr.join(str);
        else
            return arr;
    }
}
